<script>
  // components
  import DataMenu from "./menu/dataMenu.svelte";
  import DataTransformMenu from "./menu/dataTransformMenu.svelte";
  import ArtboardMenu from "./menu/artboardMenu.svelte";
  import LayoutMenu from "./menu/layoutMenu.svelte";
  import ProjectionMenu from "./menu/projectionMenu.svelte";
  import MarkMenu from "./menu/markMenu.svelte";
  import AxisMenu from "./menu/axisMenu.svelte";
  import LegendMenu from "./menu/legendMenu.svelte";
  import TitleMenu from "./menu/titleMenu.svelte";
  import AnnotationMenu from "./menu/annotationMenu.svelte";
  import InteractionMenu from "./menu/interactionMenu.svelte";
  import SelectionMenu from "./menu/selectionMenu.svelte";
  import MarkIndividualMenu from "./menu/markIndividualMenu.svelte";

  import { currMenu, systemLog } from "../editor/storage.js";
  import { onDestroy, onMount } from "svelte";

  // event functions
  export let inputFocusAction;
  export let inputBlurAction;
  export let openThirdMenu;
  export let closeThirdMenu;

  onMount(() => {
    $systemLog.log({ message: "Opened a menu", menu: $currMenu });
  });
  onDestroy(() => {
    closeThirdMenu();
  });
</script>

{#if $currMenu == "artboard"}
  <ArtboardMenu {inputFocusAction} {inputBlurAction} />
{:else if $currMenu == "data"}
  <DataMenu />
{:else if $currMenu == "data_transformation"}
  <DataTransformMenu {inputFocusAction} {inputBlurAction} />
{:else if $currMenu == "layout"}
  <LayoutMenu
    {inputFocusAction}
    {inputBlurAction}
    {openThirdMenu}
    {closeThirdMenu}
  />
{:else if $currMenu == "projection"}
  <ProjectionMenu {inputFocusAction} {inputBlurAction} />
{:else if $currMenu == "selection"}
  <SelectionMenu />
{:else if $currMenu == "mark"}
  <MarkMenu
    {inputFocusAction}
    {inputBlurAction}
    {openThirdMenu}
    {closeThirdMenu}
  />
{:else if $currMenu == "axis"}
  <AxisMenu {inputFocusAction} {inputBlurAction} />
{:else if $currMenu == "legend"}
  <LegendMenu {inputFocusAction} {inputBlurAction} />
{:else if $currMenu == "title"}
  <TitleMenu {inputFocusAction} {inputBlurAction} />
{:else if $currMenu == "annotation"}
  <AnnotationMenu {inputFocusAction} {inputBlurAction} />
{:else if $currMenu == "interaction"}
  <InteractionMenu {inputFocusAction} {inputBlurAction} />
{:else if $currMenu == "mark_individual"}
  <MarkIndividualMenu {inputFocusAction} {inputBlurAction} />
{:else}
  <section class="second-level-menu">
    <h2>{$currMenu}</h2>
  </section>
{/if}
